// extracted by mini-css-extract-plugin
export default {"container":"nr-z","heading":"or-z","text":"pr-z","info":"qr-z","link":"rr-z","fullMaxWidth":"sr-z"};